import type { DefCampo } from '../componentes/formulario';

/**
 * U15 F5: no modo simples os campos avançados de um formulário ficam atrás de "Mais opções" (o grupo recolhível do
 * `Formulario`, que abre sozinho quando um campo escondido dá erro). Só entra no grupo o campo que NÃO é obrigatório sem
 * valor padrão: obrigatório sem padrão nunca fica escondido. Desligado, devolve os campos como vieram (nada muda).
 * Os escondidos vão para o fim da lista, juntos (o `Formulario` agrupa por vizinhança).
 */
export function comMaisOpcoes(
  campos: DefCampo[],
  o: { ativo: boolean; avancados: readonly string[]; rotulo: string; inicial?: Record<string, unknown> },
): { campos: DefCampo[]; gruposRecolhiveis?: string[] } {
  if (!o.ativo) return { campos };
  const vazio = (v: unknown) => v === undefined || v === null || v === '';
  const vaiParaMais = (c: DefCampo) => o.avancados.includes(c.nome) && !(c.obrigatorio && vazio(o.inicial?.[c.nome]));
  const escondidos = campos.filter(vaiParaMais);
  if (!escondidos.length) return { campos };
  return { campos: [...campos.filter((c) => !vaiParaMais(c)), ...escondidos.map((c) => ({ ...c, grupo: o.rotulo }))], gruposRecolhiveis: [o.rotulo] };
}
